import { render, staticRenderFns } from "./order1.vue?vue&type=template&id=288f9569&scoped=true"
import script from "./order1.vue?vue&type=script&lang=js"
export * from "./order1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f9569",
  null
  
)

export default component.exports